import type { Meta } from '../db/tipos'
import type { Passos } from './configuracao'
import { arredondar2 } from '../pedidos/precos'

// Decisao dela (spec §6): quer ser empurrada nos SEIS. Mas os dois que nao sao
// dinheiro ganham passo curto e teto, porque cobertura e porcentagem
// (90% + 15% = 103,5%, impossivel) e itens por pedido JA e uma media.
export function aplicarEmpurrao(tipo: Meta['tipo'], media: number, passos: Passos): number {
  if (tipo === 'cobertura_linhas') {
    return Math.min(100, arredondar2(media + passos.pontosCobertura))
  }
  if (tipo === 'itens_por_pedido') {
    return arredondar2(media + passos.passoItensPorPedido)
  }
  const comEmpurrao = media * (1 + passos.pctDinheiro / 100)
  // Nao existe 9,2 clientes positivados.
  if (tipo === 'positivacao') return Math.round(comEmpurrao)
  return arredondar2(comEmpurrao)
}
